/* eslint-disable */
import wx from 'weixin-js-sdk'
import chttp from '@/libs/base/coupon_http'
import apis from '@/libs/base/apis'
import util from '@/libs/utils/util';
import store from '@/store'
import Cookies from 'js-cookie'
import Vue from 'vue'
import { reportPay } from '@/libs/utils/log/log'
import { getTp } from '@/libs/utils/tp'
import router from '@/router'
import { handlePaySuccess, handlePayCancel, handlePayFailed } from '@/libs/app/callback/pay'

const weixin = {
  // wxLoginUrl: '', // 授权登录url
  wxLoginUrl (page, query) {
    let queryString = ''
    const appId = store.state.appId
    for (const key in query) {
      queryString += key + '=' + query[key] + '&'
    }
    if (process.env.NODE_ENV === 'production') {
      return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=http%3A//m.ktvsky.com/vod/wx/callback&response_type=code&scope=snsapi_userinfo&state=${page}?${queryString}&connect_redirect=1#wechat_redirect`
    } else {
      return 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxb74f4a965c0baaae&redirect_uri=http%3A//m.stage.ktvsky.com/vod/wx/callback&response_type=code&scope=snsapi_userinfo&state=/' + page + '?' + queryString + '&connect_redirect=1#wechat_redirect'
    }
  },
  // 判断是否授权
  getOpenID (page, query, callback) {
    if (util.getUrlPrem('minOpenid') && util.getUrlPrem('minUnionid')) {
      store.commit('SAVE_OPENID', util.getUrlPrem('minOpenid'))
      store.commit('SAVE_UNIONID', util.getUrlPrem('minUnionid'))
      store.commit('SET_WEIXIN_APPID', util.getUrlPrem('appid').split('#/')[0])
      store.commit('IS_MIN_PROGRAM', true);
      return
    }
    // 用户openid，只跟当前公众号相关
    let openid = util.getUrlPrem('openid') || Cookies.get('openid') || store.state.openid
    // 用户unionid，用户唯一ID，不随公众号变化
    let unionid = util.getUrlPrem('unionid') || Cookies.get('unionid') || store.state.unionid
    if (openid && unionid) {
      Cookies.set('openid', openid, {
        expires: 30
      })
      Cookies.set('unionid', unionid, {
        expires: 30
      })
      store.commit('SAVE_OPENID', openid)
      store.commit('SAVE_UNIONID', unionid)
    }
  },
  isWxWebView () {
    const arr = window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i)
    if (arr && arr.length > 0 && arr[0] === 'micromessenger') {
      return true
    } else {
      return false
    }
  },
  isXcxWebView () {
    return util.getUrlPrem('browser') === 'xcx' || window.__wxjs_environment === 'miniprogram'
  },
  init (callback) {
    let req = {
      // 'action': 'js_signature',
      'type': 'thunder',
      'url': window.location.href.replace(/#.*$/, '')
    }
    // http.get(`${apis.initWx}?param=` + encodeURIComponent(JSON.stringify(req))).then(function (res) {
    chttp.get(apis.initWx + '?close_loading=true', {
      params: req,
    }).then(function (res) {
      try {
        store.commit('SET_WEIXIN_APPID', res.appId)
        wx.config({
          debug: false,
          appId: res.appId,
          timestamp: parseInt(res.timestamp),
          nonceStr: res.nonceStr,
          signature: res.signature,
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'chooseImage',
            'uploadImage',
            'scanQRCode',
            'startRecord',
            'stopRecord',
            'translateVoice',
            'chooseWXPay',
            'getLocation',
            'openLocation',
            'getLocalImgData'
          ],
          openTagList: [
            'wx-open-launch-weapp'
          ]
        })
        wx.ready(function () {
          wx.checkJsApi({
            jsApiList: [
              'chooseImage',
              'scanQRCode',
              'chooseWXPay',
              'onMenuShareTimeline',
              'onMenuShareAppMessage',
              'getLocation',
              'getLocalImgData',
              'startRecord',
              'stopRecord',
              'translateVoice'
            ],
            success: function (res) {
              callback && callback()
            },
            failed: function (err) {
              console.log('失败', err)
            },
            complete: function () { }
          })
          // 禁止微信字体缩放
          wx.invoke("setFontSizeCallback", {
            fontSize: '2'
          });
          wx.on('menu:setfont', function () {
            wx.invoke('setFontSizeCallback', { 'fontSize': 0 })
          })
        })
        wx.error(res => {
          console.log(res)
        })
      } catch (g) {
        console.log(g)
      }
      store.commit('CHANGE_HOME_BOTTOM_AD', true)
    }).catch(function (error) {
      console.log(error)
    })
  },
  updateShare (conf) {
    let settings = 'onMenuShareTimeline onMenuShareAppMessage'
    settings.split(' ').forEach(e => {
      try {
        wx[e](conf)
      } catch (g) {
        alert(g)
      }
    })
  },
  shareTimeLine (config, callback) {
    wx.onMenuShareTimeline({
      title: config.title, // 分享标题
      link: config.link || window.location.href, // 分享链接
      imgUrl: config.imgUrl, // 分享图标
      desc: config.desc,
      success: function () {
        callback && callback()
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    })
  },
  shareAppMessage (config, callback) {
    wx.onMenuShareAppMessage({
      title: config.title, // 分享标题
      desc: config.desc, // 分享描述
      link: config.link || window.location.href, // 分享链接
      imgUrl: config.imgUrl, // 分享图标
      type: '', // 分享类型,music、video或link，不填默认为link
      dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
      success: function () {
        callback && callback()
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    })
  },
  previewImage (current, urls) {
    wx.previewImage({
      current: current, // 当前显示图片的http链接
      urls: urls // 需要预览的图片http链接列表
    })
  },
  chooseImage (num, callback, flag) {
    let localIds
    wx.chooseImage({
      count: num, // 默认9
      sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
      sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
      success (res) {
        // callback && callback(res)
        localIds = res.localIds ? res.localIds : []
        if(flag){
          callback && callback(res)
        }
        uploadToWeiXin(localIds, callback)
      }
    })
    function uploadToWeiXin (ids, callback) {
      if (!ids.length) {
        return false
      }
      let length = ids.length
      let serverIds = []
      let i = 0
      upload()
      function upload () {
        wx.uploadImage({
          localId: ids[i],
          success: function (res) {
            serverIds.push(res.serverId)
            // if (num === 1 && localIds.length > 1) {
            // localIds.shift()
            // serverIds.shift()
            // }
            i++
            if (i < length) {
              upload()
            } else {
              callback && callback(serverIds)
            }
          },
          fail: function (res) {
            console.log(JSON.stringify(res))
          }
        })
      }
    }
  },
  uploadedImgs: [],
  uploadSuccessed: true,
  uploadImages (localIds, callback) {
    if (!localIds.length) return
    let localId = localIds.pop()
    let _this = this
    if (!_this.callback) {
      _this.callback = callback
    }
    wx.uploadImage({
      localId: localId, // 需要上传的图片的本地ID，由chooseImage接口获得
      isShowProgressTips: 1, // 默认为1，显示进度提示
      success (res) {
        let serverId = res.serverId
        _this.uploadedImgs.push(serverId)
        if (res.errMsg !== 'uploadImage:ok') {
          _this.uploadSuccessed = false
        }
        if (localIds.length > 0) {
          _this.uploadImages(localIds)
        } else {
          if (!_this.uploadSuccessed) return
          try {
            _this.callback(_this.uploadedImgs)
          } catch (e) {
            alert(e)
          }
        }
      }
    })
  },
  getLocalImgData (i, localIds, callback) {
    wx.getLocalImgData({
      localId: localIds[i],
      success: function (res) {
        callback && callback(res)
      },
      fail: function (res) {
        console.log(res)
      }
    })
  },
  uploadImgsFn (num, callback) {
    let _this = this
    // 选图
    _this.chooseImage(num, (chooseRes) => {
      if (chooseRes.errMsg === 'chooseImage:ok') {
        _this.uploadImages(
          chooseRes.localIds,
          (uploadImages) => {
            _this.imgServerDownload(uploadImages, (downloadRes) => {
              callback(downloadRes)
            })
          })
      }
    })
  },
  imgServerDownload (uploadImages, callback) {
    // 服务器端图片下载
  },
  scanQRCode (callback, type) {
    console.log("调用了扫码")
    wx.scanQRCode({
      desc: 'scanQRCode desc',
      needResult: type === 1 ? type : 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
      success: function (res) {
        console.log("qrCode结果", res)
        let result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
        callback && callback(result)
      }
    })
  },
  wxPay (params, url, elseData, type) {
    Vue.$fetchLoading.open('icon4')
    const startPayTime = Date.now()
    const _this = this
    if (store.state.isMinProgram) {
      const minOpenid = util.getUrlPrem('minOpenid')
      params.openid = minOpenid ? minOpenid : params.openid
      params.appid = store.state.appId
      params.is_miniapp = 1
    }
    const vipUrlArr = ['vodc/baochang-jz/wxpay', '/vodc/vip/wxpay', '/vodc/vip/experiment/wxpay', '/vodc/vip_crab/wxpay']
    chttp.post(url + '?close_loading=true', params).then(res => {
      res.errcode = parseInt(res.errcode)
      if (res.errcode === 200) {
        store.commit('SAVE_ORDER_ID', res.oid)
        store.commit('SET_STATE', {pkgLevel: res.pkgLevel}) //档位
        if (store.state.isMinProgram) {
          const payParam = {
            appid: store.state.appId,
            nonceStr: res.pay.jspay.nonceStr,
            package: res.pay.jspay.package,
            signType: res.pay.jspay.signType,
            timeStamp: res.pay.jspay.timeStamp,
            paySign: res.pay.jspay.paySign
          }
          const miniPaySuccess = () => {
            store.commit('SAVE_TOGGLE_SKELETON', false)
            if (vipUrlArr.includes(url)){ // 判断如果是充值VIP  直接设置is_vip字段为true
              store.commit('SAVE_IS_VIP')
            }
            store.commit('SAVE_TOGGLE_SKELETON', false)
            store.commit('CLOSE_PAY_PANEL');
            store.commit('SET_SHOW_PAY_TOAST', false);
            Vue.$RaiseMessage.close();
            Vue.$RaiseNewPayment({ action: 'close' });
            Vue.$RaisePaymentMessage({ action: 'close' });
            Vue.$RaiseFocusMessage({ action: 'close' });
            Vue.$fetchLoading.close()
            Vue.$messageBox.close();
            elseData.callback();
          }
          store.commit('SAVE_MINIPAY_CALLBACK', miniPaySuccess)
          _this.navigateToMiniProgram(JSON.stringify(payParam))
          return
        }
        let statData = {
          is_vip: store.state.is_vip,
          is_expired_vip: store.state.is_expired_vip,
          order_id: res.oid,
        }
        wx.chooseWXPay({
          timestamp: res.pay.jspay.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: res.pay.jspay.nonceStr, // 支付签名随机串，不长于 32 位
          package: res.pay.jspay.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
          signType: res.pay.jspay.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: res.pay.jspay.paySign, // 支付签名
          fail: function (res) {
            handlePayFailed()
            Vue.$messageBox.alert('支付失败', '')
            Vue.$fetchLoading.close()
          },
          success: function (res) {
            // 支付成功后的回调函数
            Vue.$fetchLoading.close()
            if (res.errMsg === 'chooseWXPay:ok') {
              store.commit('CLOSE_PAY_PANEL')
              if (vipUrlArr.includes(url)){ // 判断如果是充值VIP  直接设置is_vip字段为true
                store.commit('SAVE_IS_VIP')
              }
              store.commit('SET_SHOW_PAY_TOAST', false);
              Vue.$RaiseMessage.close();
              Vue.$RaiseNewPayment({ action: 'close' });
              Vue.$RaisePaymentMessage({ action: 'close' });
              Vue.$RaiseFocusMessage({ action: 'close' });
              Vue.$messageBox.close();
              typeof elseData.callback === 'function' && elseData.callback()
              handlePaySuccess(statData)
            } else {
              Vue.$messageBox.alert('支付失败', '')
            }
          },
          cancel: function (res) {
            handlePayCancel()
            reportPay({
              fee: params.pay_fee,
              order_tp: getTp(url),
              order_id: res.oid,
              page_tp: params.page_tp, // 扫码来源：0：vip开屏弹窗;1：遥控器;2：我的页开通;3：舞曲串烧歌单;4：详情页1日弹窗;5：开场特效
              active_tp: 1, // 用户行为：0：点击
              stay_time: Date.now() - startPayTime, // 停留时间(单位：毫秒)
              tc_tp: params.pkg_id
            })
            // 支付取消回调函数
            Vue.$fetchLoading.close()
            let options = {}
            typeof elseData.cancelCloseCallBack === 'function' && (options.callback = elseData.cancelCloseCallBack)
            // Vue.$messageBox.alert('支付取消', '', options)
            // 支付取消回调配置项
            typeof elseData.cancelcallback === 'function' && elseData.cancelcallback()
          }
        })
        // 下单用户打点
        let tp = getTp(url)
        if (!tp) return
        reportPay({
          fee: params.pay_fee,
          order_tp: tp,
          order_id: res.oid,
          page_tp: params.page_tp, // 扫码来源：0：vip开屏弹窗;1：遥控器;2：我的页开通;3：舞曲串烧歌单;4：详情页1日弹窗;5：开场特效
          active_tp: 0, // 0：点击 ;1：停留
          tc_tp: params.pkg_id
        })
      } else if (res.errcode === 52000) {
        Vue.$toast(res.errmsg)
      } else {
        if (url.indexOf('vodc/baochang-jz/wxpay') != -1) {
          if(res.errmsg === '获取绑定房台信息空'){
            Vue.$store.commit('SAVE_SHOW_SCODE_BOX', true);
          }else if (res.errmsg === '该房台已包场') {
            Vue.$messageBox
              .confirm('赶快去跪舔金主吧', '包房已有金主', {
                confirmButtonText: '立即去玩',
                cancelButtonText: '取消',
              })
              .then(() => {
                router.push('/thunder/interact');
              });
          }
        } else {
          handlePayFailed()
          Vue.$toast('支付失败')
        }
      }
      Vue.$fetchLoading.close()
    }).catch(err => {
      console.log(err)
      handlePayFailed()
      Vue.$fetchLoading.close()
      Vue.$toast('支付失败')
    })
  },
  startRecord (successCallback, cancelCallback) {
    wx.startRecord({
      success () {
        successCallback && successCallback()
      },
      cancel () {
        cancelCallback && cancelCallback()
        Vue.$messageBox.alert('您已拒绝授权录音,将无法使用该功能！', '')
      }
    })
  },
  stopRecord (callback, callback1) {
    wx.stopRecord({
      success (res) {
        if (callback) {
          return wx.translateVoice({
            localId: res.localId, // 需要识别的音频的本地Id，由录音相关接口获得
            isShowProgressTips: 1, // 默认为1，显示进度提示
            success: function (res) {
              callback && callback(res.translateResult)
            },
            fail: function (err) {
              Vue.$messageBox.alert('您的声音太小啦~</br>系统未听清您想搜索的内容', '', { confirmButtonText: '再试一次' })
              callback1 && callback1()
            }
          })
        }
      },
      fail: function (err) {
        Vue.$messageBox.alert('您的声音太小啦~</br>系统未听清您想搜索的内容', '', { confirmButtonText: '再试一次' })
        callback1 && callback1()
      }
    })
  },
  getLocation (that, callback) {
    wx.getLocation({
      type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      success: function (res) {
        that.latitude = res.latitude // 纬度，浮点数，范围为90 ~ -90
        that.longitude = res.longitude // 经度，浮点数，范围为180 ~ -180。
        typeof callback === 'function' && callback()
      },
      fail: function (err) {
        if (err.errMsg.indexOf('getLocation:fail') >= 0) {
          location.reload()
        } else {
          console.log(err)
        }
      },
      cancel: function () {
        typeof callback === 'function' && callback()
      }
    })
  },
  checkIsFromMiniProgram (callback) {
    wx.miniProgram.getEnv(function (res) {
      callback && callback(res.miniprogram)
    })
  },
  // 跳转到小程序
  navigateToMiniProgram (params, path) {
    const url = path || '/pages/xcx_pay/xcx_pay?payParam=' + encodeURIComponent(params)
    wx.miniProgram.navigateTo({
      url: url,
      success: function (res) {
      },
      fail (res) {
        console('fail', res)
      }
    }

    )
  }
}

export default weixin
